import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  getId,
  createItem,
  updateItem,
  deleteById,
  deleteByIdImage,
  uploadItemValidate,
  upload,
  getExport,
  getAllDatalog,
  getIdDatalog,
} from "./customerAPI";

const initialState = {
  data: [],
  data2: [],
  dataId: null,
  dataId2: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchCustomer = createAsyncThunk(
  "customer/fetchCustomer",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);

export const fetchData = createAsyncThunk(
  "customer/fetchData",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);

export const fetchId = createAsyncThunk("customer/fetchId", async (id) => {
  const response = await getId(id);
  return response;
});

export const fetchDatalog = createAsyncThunk(
  "datalog/fetchDatalog",
  async (payload) => {
    const response = await getAllDatalog(payload);
    return response;
  }
);

export const fetchIdDatalog = createAsyncThunk(
  "datalog/fetchIdDatalog",
  async (id) => {
    const response = await getIdDatalog(id);
    return response;
  }
);

export const fetchIdNoloading = createAsyncThunk(
  "customer/fetchIdNoloading",
  async (id) => {
    const response = await getId(id);
    return response;
  }
);

export const addItem = createAsyncThunk(
  "customer/addItem",
  async ({ payload, files, filesLokasi }) => {
    const response = await createItem(payload, files, filesLokasi);
    return response;
  }
);

export const editItem = createAsyncThunk(
  "customer/editItem",
  async ({ payload, files, filesLokasi }) => {
    const response = await updateItem(payload, files, filesLokasi);
    return response;
  }
);
export const removeById = createAsyncThunk(
  "customer/removeById",
  async (payload) => {
    const response = await deleteById(payload);
    return response;
  }
);

export const removeImage = createAsyncThunk(
  "customer/removeImage",
  async (payload) => {
    const response = await deleteByIdImage(payload);
    return response;
  }
);

export const uploadValidate = createAsyncThunk(
  "customer/uploadValidate",
  async (payload) => {
    const response = await uploadItemValidate(payload);
    return response;
  }
);
export const uploadItem = createAsyncThunk(
  "customer/uploadItem",
  async (payload) => {
    const response = await upload(payload);
    return response;
  }
);

export const fetchExport = createAsyncThunk(
  "customer/fetchExport",
  async (payload) => {
    const response = await getExport(payload);
    return response;
  }
);

export const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomer.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCustomer.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchIdNoloading.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchIdNoloading.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeImage.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeImage.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(uploadItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(uploadValidate.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadValidate.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchExport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchExport.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchDatalog.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDatalog.fulfilled, (state, action) => {
        state.loading = false;
        state.data2 = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchIdDatalog.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdDatalog.fulfilled, (state, action) => {
        console.log(action, "action");
        state.loading = false;
        state.dataId2 = action.payload.data;
      });
  },
});

export const { resetData, setSelected } = customerSlice.actions;

export const selectCustomer = (state) => state.customer.data;
export const selectData = (state) => state.customer.data;
export const selectId = (state) => state.customer.dataId;
export const selectDatalog = (state) => state.customer.data2;
export const selectIdDatalog = (state) => state.customer.dataId2;
export const selectLoading = (state) => state.customer.loading;
export const selectError = (state) => state.customer.error;
export const selectPageNo = (state) => state.customer.pageNo;
export const selectPageSize = (state) => state.customer.pageSize;
export const selectTotalRecord = (state) => state.customer.totalRecord;
export const selectSelected = (state) => state.customer.selected;
export const selectResult = (state) => state.customer.result;

export default customerSlice.reducer;
